import {RequestState} from "../../requestState";
import vue from "vue";

function calculateKey(table, id) {
  return `${table}/${id}`
}

export function getMetadataSection(state) {
  return (table, id) => {
    const key = calculateKey(table, id);

    let result = state.metadata[key];

    if (!result) {
      result = {
        requestState: RequestState.NotPerformed,
        response: null,
        error: null
      };

      vue.set(state.metadata, key, result);
    }
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/store/getters/metadata.js